import { MicOff } from "lucide-react";

/**
 * "Can't be heard right now" on a speaker's tile (#2224 AC27, AC27b, AC34),
 * shared by the signed-in `CallTile` and the guest page's tile. Top-centre,
 * clear of the hand/twin/mute badges on the start side and the reaction or
 * "You" badge on the end side. Fixed colours: it sits on video or an avatar,
 * not on the page theme.
 */
export function NotHeardTileMark({ label }: { label: string }) {
  return (
    <div
      data-testid="tile-not-heard"
      role="status"
      className="absolute top-2 left-1/2 -translate-x-1/2 flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium shadow max-w-[calc(100%-5rem)]"
      style={{ background: "rgba(185, 28, 28, 0.92)", color: "#fff" }}
    >
      <MicOff className="size-3 shrink-0" aria-hidden />
      <span className="truncate">{label}</span>
    </div>
  );
}
